import { render, staticRenderFns } from "./TiptapField.vue?vue&type=template&id=69b2293a&scoped=true&"
import script from "./TiptapField.vue?vue&type=script&lang=js&"
export * from "./TiptapField.vue?vue&type=script&lang=js&"
import style0 from "./TiptapField.vue?vue&type=style&index=0&id=69b2293a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b2293a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTab,VTabItem,VTabs,VTextarea})
